import React, { createContext, useContext, useState, useEffect } from 'react';

interface PresentationModeContextType {
    isCandidateMode: boolean;
    toggleCandidateMode: () => void;
    setCandidateMode: (enabled: boolean) => void;
}

const PresentationModeContext = createContext<PresentationModeContextType>({
    isCandidateMode: false,
    toggleCandidateMode: () => {},
    setCandidateMode: () => {},
});

export const PresentationModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isCandidateMode, setIsCandidateMode] = useState<boolean>(() => {
        const saved = localStorage.getItem('sewa_crm_candidate_mode');
        return saved === 'true';
    });

    useEffect(() => {
        localStorage.setItem('sewa_crm_candidate_mode', String(isCandidateMode));
    }, [isCandidateMode]);

    const toggleCandidateMode = () => setIsCandidateMode(prev => !prev);
    const setCandidateMode = (enabled: boolean) => setIsCandidateMode(enabled);

    return (
        <PresentationModeContext.Provider value={{ isCandidateMode, toggleCandidateMode, setCandidateMode }}>
            {children}
        </PresentationModeContext.Provider>
    );
};

export const usePresentationMode = () => useContext(PresentationModeContext);
